//WE.Flow.Html.Models.Theme

export class Theme {
    id: string = "";
    name: string = "";
}
